import React, { useMemo } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { convertTimeStringWithDuration } from '_utils/function'
import { PAYMENT_METHOD_HIT_PAY } from '_utils/constant'
import { useCombinedPaymentOrders } from '../ManageOrder/hooks'

const BoxForOrder = ({ order }) => (
  <div style={{ border: '1px solid', position: 'relative', margin: '15px 0' }}>
    <div className='truncate'>
      <span style={{ color: '#0BADAD' }}>[Order No: {order.eOrderNo}] </span>
      <span>{order.eTitle}</span>
    </div>
    <div style={{ marginTop: 10, padding: '10px 13px', fontSize: '0.9rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>Admin Fee</div>
        <div>${order?.adminCostPerOrder?.toFixed(2)}</div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>Delivery Fee</div>
        <div>${order?.deliveryPerOrder?.toFixed(2)}</div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>Discount Fee</div>
        <div>${order?.discountPerOrder?.toFixed(2)}</div>
      </div>
      {order?.allProductPerOrder.map((item, _index) => (
        <React.Fragment key={_index}>
          <div>
            <span>{item.pName} </span>
            {item.pSubItems && item.pSubItems.length > 0 ? (
              <>
                (
                {item.pSubItems.map((_item, idex) => (
                  <span key={idex}>
                    {_item.name} {_item.qty > 1 ? `x${_item.qty}` : ''} {_item.price > 0 ? `(+$${Number(_item.price).toFixed(2)})` : ''}
                    {idex === item.pSubItems.length - 1 ? '' : ', '}
                  </span>
                ))}
                )
              </>
            ) : null}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div>x{item.pQuantity}</div>
            <div>${Number(item.pPrice * item.pQuantity).toFixed(2)}</div>
          </div>
        </React.Fragment>
      ))}
    </div>
  </div>
)

const BoxForDelivery = ({ delivery }) => (
  <div style={{ border: '1px solid', position: 'relative', margin: '15px 0' }}>
    <div className='truncate'>
      <span>
        Delivery for (
        {convertTimeStringWithDuration(delivery.dDeliveryTime, delivery.dDeliveryDuration)})
      </span>
    </div>
    <div style={{ marginTop: 10, padding: '10px 13px', fontSize: '0.9rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <div>Delivery Personal Fee</div>
        <div>${delivery.dzPrice?.toFixed(2)}</div>
      </div>
    </div>

    <div style={{ borderTop: '1px solid', fontSize: '0.9rem' }}>
      <div style={{ padding: '10px 13px' }}>
        {`Location: ${delivery.dzName}, address: ${delivery.address}`}
      </div>
    </div>
  </div>
)

export default function ModalPaymentScreen({
  data,
  modalPaymentScreen,
  togglePaymentScreen,
  handleInvalidPayment,
}) {
  const checkPayHitPay = data?.paymentType === PAYMENT_METHOD_HIT_PAY

  const {
    combinedOrders,
    combinedDeliveries,
    isLoadingCombined,
  } = useCombinedPaymentOrders(data, { enabled: modalPaymentScreen })

  const listCombinedOrder = useMemo(() => {
    if (combinedOrders && combinedOrders.length > 0) return combinedOrders
    if (data?.listCombinedOrder && data.listCombinedOrder.length > 0) return data.listCombinedOrder
    return []
  }, [combinedOrders, data?.listCombinedOrder])

  const listCombinedDelivery = useMemo(() => {
    if (combinedDeliveries && combinedDeliveries.length > 0) return combinedDeliveries
    if (data?.listCombinedDelivery && data.listCombinedDelivery.length > 0) {
      return data.listCombinedDelivery
    }
    return []
  }, [combinedDeliveries, data?.listCombinedDelivery])

  const totalPay = useMemo(() => {
    let price = 0
    if (listCombinedOrder && listCombinedOrder.length) {
      listCombinedOrder.forEach((el) => {
        price += (el.totalFee || 0)
      })
    }
    if (listCombinedDelivery && listCombinedDelivery.length) {
      listCombinedDelivery.forEach((el) => {
        price += (el.dzPrice || 0)
      })
    }
    return price
  }, [listCombinedOrder, listCombinedDelivery])

  return (
    <div>
      <Modal
        isOpen={modalPaymentScreen}
        toggle={togglePaymentScreen}
        scrollable={true}
        centered
        size='xl'
        style={{ fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}
      >
        <ModalHeader style={{ margin: '0 auto', padding: 0, border: 0 }}>
          <span className='c-txt-gra'>{data?.uName}</span>
          <br />
          <span className='c-txt-gra'>
            {' '}
            Payment made for $
            {data && data.totalFee >= 0 ? data?.totalFee?.toFixed(2) : data?.dzPrice?.toFixed(2)}
          </span>
        </ModalHeader>
        <ModalBody className='d-flex flex-column'>
          {data?.paymentScreenshot && (
            <img
              className='mb-2'
              style={{ margin: '0 auto' }}
              src={data.paymentScreenshot}
              alt=''
            />
          )}
          {isLoadingCombined ? (
            <div style={{ textAlign: 'center', padding: '24px 0', color: '#7c797a' }}>
              Loading payment details...
            </div>
          ) : (listCombinedOrder.length > 0 || listCombinedDelivery.length > 0) ? (
            <div style={{ display: 'flex', flexDirection: 'column', fontSize: '1rem' }}>
              {listCombinedDelivery.map((delivery, index) => (
                <BoxForDelivery key={index} delivery={delivery} />
              ))}
              {listCombinedOrder.map((order, idex) => (
                <BoxForOrder key={idex} order={order} />
              ))}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  fontSize: '1.2rem',
                  color: '#ff6903',
                }}
              >
                <div>Total</div>
                <div>${totalPay.toFixed(2)}</div>
              </div>
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'center', flexDirection: 'row', border: 0 }}>
          <div className='col-8 px-0 m-0' style={{ flexBasis: '70%' }}>
            <button className='btn btn--org btn--org02' onClick={togglePaymentScreen}>
              OK
            </button>
          </div>
          {!checkPayHitPay && <div
            className='col-8 px-0 m-0'
            style={{ flexBasis: '70%', paddingTop: 10, textAlign: 'center', cursor: 'pointer' }}
            onClick={() =>
              handleInvalidPayment(
                data.ref,
                data.status,
                data.combinedPaymentRef,
                data.eid
              )
            }
          >
            If invalid payment, click here
          </div>}
        </ModalFooter>
      </Modal>
    </div>
  )
}
